import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { LazyComponentWithSuspense } from '../components/LazyLoader';

const PageNotFound = LazyComponentWithSuspense(() => import('../pages/PageNotFound/PageNotFound'));
const ChatPage = LazyComponentWithSuspense(() => import('../pages/ChatPage'));

export default function ChatRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={<ChatPage/>}
      />

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}
